<h2 mat-dialog-title>Error</h2>
<div mat-dialog-content>
  <p>{{errorMessage}}</p>
</div>
<mat-divider></mat-divider>
<div mat-dialog-actions align="end">
  <button class="button button--muted" mat-dialog-close="false">Close</button>
</div>
